export const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return parts[0].charAt(0).toUpperCase() + (parts.length > 1 ? parts[parts.length - 1].charAt(0).toUpperCase() : '');
};

export const getScoreChipColor = (score) => {
    if (score === null || score === undefined || typeof score !== 'number') return "default";
    const normalizedScore = Math.min(Math.max(score, 0), 1);
    if (normalizedScore >= 0.75) return "success";
    if (normalizedScore >= 0.5) return "info";
    if (normalizedScore >= 0.25) return "warning";
    return "default";
};

export const getScoreColorForText = (score, theme) => {
    if (!theme || !theme.palette) { // Guard against undefined theme
        console.error("Theme or theme.palette is undefined in getScoreColorForText");
        return '#000000'; // Fallback color
    }
    if (score === null || score === undefined || typeof score !== 'number') return theme.palette.text.disabled;
    const normalizedScore = Math.min(Math.max(score, 0), 1);
    if (normalizedScore >= 0.75) return theme.palette.success.main;
    if (normalizedScore >= 0.5) return theme.palette.info.main;
    if (normalizedScore >= 0.25) return theme.palette.warning.main;
    return theme.palette.error.main;
};